import { Point, SyntaxNode } from "web-tree-sitter"

export function getTextRange(...nodes: SyntaxNode[]): TextRange {
    const lowestNode = nodes.reduce((prev, curr) => curr.startIndex < prev.startIndex ? curr : prev);
    const highestNode = nodes.reduce((prev, curr) => curr.startIndex > prev.startIndex ? curr : prev);
    return {
        // from and to: minimum and maximum start and end indexes to get maximum range.
        from: {
            line: lowestNode.startPosition.row,
            ch: lowestNode.startPosition.column
        },
        to: {
            line: highestNode.endPosition.row,
            ch: highestNode.endPosition.column
        },
    }
}

export type TextRange = {
    from: {line: number, ch: number},
    to: {line: number, ch: number},
}